import { motion } from "framer-motion";

const steps = [
  {
    no: "01",
    title: "Understand",
    desc: "We start with the records, responsibilities, and deadlines that shape your financial workflow.",
  },
  {
    no: "02",
    title: "Organize",
    desc: "We bring the work into a clear, consistent process built around accuracy and readiness.",
  },
  {
    no: "03",
    title: "Support",
    desc: "We stay close to the details so your books and tax preparation keep moving with less friction.",
  },
];

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="bg-[#F3F2EF] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <p className="label-tech !text-[#3B37E5] mb-8">A dependable rhythm</p>
          <h2 className="font-display text-5xl md:text-6xl leading-[0.98] text-[#0A0A0A]">
            Clear work, from first record to final review.
          </h2>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-3 border-t border-[#D4D4D4]">
          {steps.map((s, i) => (
            <motion.div
              key={s.no}
              data-testid={`process-step-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="pt-8 md:pt-10 pb-2 md:px-7 md:first:pl-0 border-t border-[#D4D4D4] md:border-t-0 md:border-l md:first:border-l-0"
            >
              <span className="font-body font-semibold text-sm text-[#3B37E5]">{s.no}</span>
              <h3 className="font-display text-2xl md:text-[1.6rem] text-[#0A0A0A] mt-10 mb-4">
                {s.title}
              </h3>
              <p className="text-[#52525B] leading-relaxed max-w-[26ch]">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
